import script from "./Dropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./Dropdown.vue?vue&type=script&setup=true&lang=js"

import "./Dropdown.vue?vue&type=style&index=0&id=f5b6fb58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5b6fb58"]])

export default __exports__